import { API_STAT_UNITS } from '../../../utils/constants/api';

export function parseRadarStats(radarStats, template, radarStatsLA) {
  if (!template) return {};

  const traitTemplate = template.secondaryStats?.map((m) => m.name) || [];
  const perfTemplate = template.stats?.map((m) => m.name) || [];

  const radarTraitStats = {};
  const radarPerfStats = {};
  const radarTraitStatsLA = {};
  const radarPerfStatsLA = {};

  if (radarStats) {
    traitTemplate.forEach((attr) => {
      radarTraitStats[attr] = radarStats[attr];
    });
    radarTraitStats.plays = radarStats?.plays;

    perfTemplate.forEach((attr) => {
      radarPerfStats[attr] = radarStats[attr];
    });
    radarPerfStats.plays = radarStats?.plays;
  }

  if (radarStatsLA) {
    traitTemplate.forEach((attr) => {
      radarTraitStatsLA[attr] = radarStatsLA[attr];
    });
    radarTraitStatsLA.plays = radarStatsLA?.plays;

    perfTemplate.forEach((attr) => {
      radarPerfStatsLA[attr] = radarStatsLA[attr];
    });
    radarPerfStatsLA.plays = radarStatsLA?.plays;
  }

  return {
    radarTraitStats,
    radarPerfStats,
    radarTraitStatsLA,
    radarPerfStatsLA,
  };
}

export function buildRadarData(
  radarStats,
  templateConfig,
  radarComparisonStats,
) {
  if (!templateConfig) return [];

  return templateConfig.map((item) => ({
    minValue: item.min,
    maxValue: item.max,
    decimalPlaces: 1,
    label: item.name,
    tooltip: item.description,
    value:
      item.units === API_STAT_UNITS.PERCENTAGE
        ? radarStats?.[item.key] * 100
        : radarStats?.[item.key],
    comparisonValue:
      radarComparisonStats && item.units === API_STAT_UNITS.PERCENTAGE
        ? radarComparisonStats?.[item.key] * 100
        : radarComparisonStats?.[item.key],
    key: item.key,
  }));
}

export const loadingRadarMsg = (
  isConfigLoading,
  isStatsLoading,
  statsLoadingLA,
) => {
  if (isConfigLoading) {
    return 'Loading Templates';
  }

  if (isStatsLoading) {
    return 'Loading Player Stats ';
  }

  if (statsLoadingLA) {
    return 'Loading League Average Data';
  }

  return '';
};
